import { Component, OnInit } from '@angular/core';
import {Cerf} from '../../interfaces/Cerf';
import {Pagination} from '../../../utilities/interfaces/Pagination';
import {getLocalDateTimeString, numberFormatter, propertyOf} from '../../../utilities/utils';
import {DataTableButton} from '../../../utilities/interfaces/DataTableButton';
import {environment} from '../../../../../environments/environment';
import {Router} from '@angular/router';
import {CurrentUserService} from '../../../user/services/current-user/current-user.service';
import {CerfService} from '../../services/cerf/cerf.service';
import {AirportParams} from '../../../airport/interfaces/AirportParams';
import {CerfParams} from '../../interfaces/CerfParams';
import {UserModel} from '../../../user/models/UserModel';
import {DataGridColumn} from '../../../utilities/components/data-grid/data-grid.component';
import {DataGridColumnFilter} from '../../../utilities/components/data-grid-column-filter/data-grid-column-filter.component';

@Component({
  selector: 'app-cerf-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  cerfs: Pagination<Cerf>;
  buttons: DataTableButton[] = [
    {
      icon: 'visibility',
      action: (row) => this.router.navigate(['cerf', row.id]),
      link: (row) => environment.appUrl + '/cerf/' + row.id,
      tooltip: 'View CERF',
    }
  ];

  columns: DataGridColumn<Cerf>[] = [
    {name: 'Location', prop: 'airport.name' as any, sortable: true},
    {name: 'Name', prop: propertyOf<Cerf>('name') , sortable: true},
    {name: 'Requested', prop: propertyOf<Cerf>('created_at'), map: (created_at) => getLocalDateTimeString(created_at), sortable: true},
    {name: 'Budgeted/Unbudgeted', prop: propertyOf<Cerf>('budgeted'),
      map: (value) => Number(value) ? 'Budgeted' : 'Unbudgeted', sortable: true},
    {name: 'Cerf#', prop: propertyOf<Cerf>('cerf_number'), filter: {type: 'text'}, value: '', sortable: true},
    {name: 'Total Cost', prop: propertyOf<Cerf>('total_costs'), map: (value) => numberFormatter.format(value), sortable: true},
    {name: 'Status', prop: propertyOf<Cerf>('status'),
      getValue: (row) => row.approval_from ? row.status + ' from ' + row.approval_from : row.status, sortable: true}
  ];

  private currentUser: UserModel;
  cerfNumberParam = '';

  constructor(
    private router: Router,
    private userService: CurrentUserService,
    public cerfService: CerfService) { }

  ngOnInit() {
    this.userService.getCurrentUser().subscribe((user) => {
        this.currentUser = user;
        this.getCerfs({cerf_number: this.cerfNumberParam});
      }
    );
  }

  onFiltered(filters: DataGridColumnFilter[]) {
    const filter = filters.find(f => f.column === 'cerf_number');
    if (filter) {
      this.cerfNumberParam = filter.value;
    }
    this.getCerfs({cerf_number: this.cerfNumberParam, page: 1});
  }

  onPageChanged(page) {
    this.getCerfs({page: page});
  }

  /**
   * Fetches the airports
   *
   * @note We also have to map over the response so we can add in a nicename
   * for the timezone
   *
   * @param {AirportParams} params
   */
  getCerfs(params?: CerfParams): void {
    console.log(params);
    this.cerfService
      .getCerfs(params)
      .then((response) => this.cerfs = {
        ...response,
        // we're transforming the data here so we can convert the timezone to the nicer name on the table
        data: response.data.map(cerf => (
          {...cerf}
        ))
      });
  }

  onLimitChanged(limit) {
    this.getCerfs({limit: limit, page: 1});
  }

  onSorted(sort) {
    const orderBy = sort.sorts[0].prop;
    this.getCerfs({
      orderBy: orderBy,
      direction: sort.newValue
    });
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/cerf/components/dashboard/dashboard.component.ts